import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/AgeWage-Icon.svg'
import _imports_1 from '@/assets/AgeWage.svg'


const _hoisted_1 = {
  "data-testid": "resetpassword",
  class: "page login-page"
}
const _hoisted_2 = { class: "login-logo mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_layout, { class: "login-layout" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "d-flex justify-center align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              xs: 8,
              sm: 7,
              md: 5,
              lg: 4,
              xl: 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_img, {
                    src: _imports_0,
                    class: "logo-icon"
                  }),
                  _createVNode(_component_v_img, {
                    src: _imports_1,
                    class: "logo-text"
                  })
                ]),
                _createElementVNode("div", null, [
                  (_ctx.resetEmailSent)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        "data-testid": "invalid-alert",
                        border: "end",
                        elevation: "2",
                        "border-color": "success",
                        class: "login-alert",
                        text: "Reset email is sent."
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.resetEmailError)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        "data-testid": "invalid-alert",
                        border: "end",
                        elevation: "2",
                        "border-color": "error",
                        class: "login-alert",
                        text: "Error sending reset email. Please check email and try again"
                      }))
                    : _createCommentVNode("", true),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header-text ma-3" }, [
                    _createElementVNode("h1", { class: "mb-4" }, "Reset Password"),
                    _createElementVNode("div", { class: "sub-text mb-12" }, "Enter your email to receive the reset password email.")
                  ], -1)),
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.valid,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.valid) = $event)),
                    onSubmit: _withModifiers(_ctx.checkCredentials, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        "data-testid": "email-field",
                        id: "email",
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                        disabled: _ctx.isLoading,
                        rules: [_ctx.getErrors('email'), _ctx.rules.email],
                        class: "input-wrapper-email my-2 text-left",
                        required: "",
                        "prepend-inner-icon": "far fa-envelope",
                        height: 55,
                        name: "email",
                        variant: "solo",
                        placeholder: "ex. johndoe@email.com",
                        type: "email"
                      }, null, 8, ["modelValue", "disabled", "rules"]),
                      _createVNode(_component_v_btn, {
                        "data-testid": "login-btn",
                        loading: _ctx.isLoading,
                        color: "warning",
                        type: "submit",
                        height: 55,
                        block: ""
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("div", { class: "login-btn-text" }, "Reset password", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onSubmit"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}